module.exports = __webpack_public_path__ + "img/iso14001.ce48f11.png";